export default "https://cdn-static.gokick.com/assets/45a1ec4753cb63ac9804059da02cc099817f84d7/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";